import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { PushNotificationActionPerformed } from "../IPushNotificationAdapter";
import { extractNotificationUrl } from "../utils/extractNotificationUrl";

export const useDeepLinkNavigation = () => {
  const navigate = useNavigate();

  const handleNotificationAction = useCallback(
    (actionPerformed: PushNotificationActionPerformed<unknown>) => {
      const { notification } = actionPerformed;

      console.log("[RMD]: handleNotificationAction", actionPerformed);

      const url = extractNotificationUrl(notification);

      if (!url) {
        return;
      }

      if (isInternalAppRoute(url)) {
        navigate(url);
      } else {
        console.log("[RMD]: Ignoring external or API URL from notification:", url);
      }
    },
    [navigate],
  );

  return { handleNotificationAction };
};

function isInternalAppRoute(url: string): boolean {
  if (url.includes("://")) return false;

  if (url.startsWith("/api/")) return false;

  return true;
}
